import {createContext, useContext} from 'react';

import {
  ClientResponse,
  Conversation,
  ConversationContext,
  initObservability,
  RequestAction,
} from '@stripe-internal/conversations-client';
import {
  InlineDataEventBus,
  InlineDataService,
} from '@stripe-internal/inline-data';

import {Api} from '../lib/api/api';
import {App, AppConfig, AppProfile, AppState, AppStateStore} from '../types';
import {NoMessageBus} from '../lib/parentMessageBus/ParentMessageBus';
import {SupportConversationsClient} from '../lib/SupportConversationsClient';

const noObservability = initObservability({});

const Uninitialized: App = {
  get stateStore(): AppStateStore {
    throw new Error('Uninitialized');
  },
  get state(): AppState {
    throw new Error('Uninitialized');
  },
  get api(): Api {
    throw new Error('Uninitialized');
  },
  get inlineDataEventBus(): InlineDataEventBus {
    throw new Error('Uninitialized');
  },
  get config(): AppConfig {
    throw new Error('Uninitialized');
  },
  get profile(): AppProfile {
    throw new Error('Uninitialized');
  },
  get client(): SupportConversationsClient {
    throw new Error('Uninitialized');
  },
  get inlineDataService(): InlineDataService {
    throw new Error('Uninitialized');
  },
  hasFlag(_: string): boolean {
    return false;
  },
  requestAction(_: Omit<RequestAction, 'name'>): Promise<ClientResponse> {
    throw new Error('Uninitialized');
  },
  getConversation(_: string): Conversation | undefined {
    throw new Error('Uninitialized');
  },
  startConversation(_: {
    conversationId?: string;
    initialQuery?: string;
    restart?: boolean;
    context?: Partial<ConversationContext>;
  }): Promise<Conversation | null> {
    throw new Error('Uninitialized');
  },
  restartConversation(_: {
    initialQuery?: string;
  }): Promise<Conversation | null> {
    throw new Error('Uninitialized');
  },
  endConversation(): Promise<void> {
    throw new Error('Uninitialized');
  },
  resumeOrStartConversation(_: {
    conversationId?: string;
    initialQuery?: string;
    restart?: boolean;
    context?: Partial<ConversationContext>;
  }): Promise<Conversation | null> {
    throw new Error('Uninitialized');
  },
  open(): void {
    throw new Error('Uninitialized');
  },
  close(): void {
    throw new Error('Uninitialized');
  },
  minimize() {
    throw new Error('Uninitialized');
  },
  destroy() {
    throw new Error('Uninitialized');
  },
  parentMessageBus: NoMessageBus,
  errors: noObservability.errors,
  analytics: noObservability.analytics,
  metrics: noObservability.metrics,
};

export const AppContext = createContext<App>(Uninitialized);

export function useApp(): App {
  return useContext(AppContext);
}
